import React, { useState, useRef, useCallback, useEffect } from 'react';
import JsSIP from 'jssip';
import './App.css';

const WS_SERVER = 'wss://voiceconnect.dvjnoc.com:47631/ws';
const SIP_DOMAIN = 'voiceconnect.dvjnoc.com';
const TENANT = '99909255';
const TURN_SERVER = 'voiceconnect.dvjnoc.com';
const TURN_SECRET = 'ab64892bd6afa177df5d6b749dc5171e8f77c7ffb2c6e1c5035c8f348fb74429';
const MAX_RECENTS = 20;
const MAX_CONF = 5;
const EXTENSIONS = ['2001','2002','2003','2004','2005'];

const TAB = { KEYPAD:'keypad', RECENTS:'recents', CONTACTS:'contacts' };
const SCREEN = { LOGIN:'login', MAIN:'main', CALL:'call', CONF:'conf', SETTINGS:'settings', MIC_TEST:'mic_test', NET_TEST:'net_test' };

async function getTurnCredentials() {
  const ts = Math.floor(Date.now()/1000)+3600;
  const u = String(ts);
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey('raw', enc.encode(TURN_SECRET), {name:'HMAC',hash:'SHA-1'}, false, ['sign']);
  const sig = await crypto.subtle.sign('HMAC', key, enc.encode(u));
  const cred = btoa(String.fromCharCode(...new Uint8Array(sig)));
  return {username:u, credential:cred};
}

async function getIceServers() {
  const {username,credential} = await getTurnCredentials();
  return [
    {urls:'stun:stun.l.google.com:19302'},
    {urls:`stun:${TURN_SERVER}:3478`},
    {urls:`turn:${TURN_SERVER}:3478`, username, credential},
    {urls:`turn:${TURN_SERVER}:3478?transport=tcp`, username, credential},
    {urls:`turns:${TURN_SERVER}:5349`, username, credential},
  ];
}

function playTone(audioCtxRef, type) {
  try {
    const ctx = new (window.AudioContext||window.webkitAudioContext)();
    audioCtxRef.current = ctx;
    const master = ctx.createGain(); master.gain.value = type==='incoming'?0.3:0.15; master.connect(ctx.destination);
    const bursts = type==='incoming'?30:20;
    for(let i=0;i<bursts;i++) {
      [400,450].forEach(f => {
        const osc = ctx.createOscillator(); const g = ctx.createGain();
        osc.frequency.value=f; osc.type='sine'; osc.connect(g); g.connect(master);
        const t = ctx.currentTime + i*3;
        g.gain.setValueAtTime(0,t); g.gain.linearRampToValueAtTime(1,t+0.01);
        g.gain.setValueAtTime(1,t+0.4); g.gain.linearRampToValueAtTime(0,t+0.41);
        g.gain.setValueAtTime(0,t+0.61); g.gain.linearRampToValueAtTime(1,t+0.62);
        g.gain.setValueAtTime(1,t+1.02); g.gain.linearRampToValueAtTime(0,t+1.03);
        osc.start(t); osc.stop(t+1.03);
      });
    }
  } catch(e){}
}
function stopTone(audioCtxRef) { try { if(audioCtxRef.current){audioCtxRef.current.close();audioCtxRef.current=null;} } catch(e){} }

function formatDur(s) { return `${Math.floor(s/60).toString().padStart(2,'0')}:${(s%60).toString().padStart(2,'0')}`; }
function ukTime(fmt) {
  const d = new Date();
  if(fmt==='time') return d.toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit',second:'2-digit',timeZone:'Europe/London'});
  if(fmt==='clock') return d.toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit',timeZone:'Europe/London'});
  return d.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short',timeZone:'Europe/London'});
}

function PhoneIcon({size=20,color='white'}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.32.57 3.58.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.29 21 3 13.71 3 4.5c0-.55.45-1 1-1H7.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.23 1.01L6.6 10.8z" fill={color}/></svg>;
}
function HangupIcon({size=20}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.32.57 3.58.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.29 21 3 13.71 3 4.5c0-.55.45-1 1-1H7.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.23 1.01L6.6 10.8z" fill="white" transform="rotate(135 12 12)"/></svg>;
}
function MicIcon({crossed=false,size=18}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-6 0V4a3 3 0 0 1 3-3z"/>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
    <line x1="12" y1="19" x2="12" y2="23"/>
    <line x1="8" y1="23" x2="16" y2="23"/>
    {crossed && <line x1="2" y1="2" x2="22" y2="22" strokeWidth="2.5"/>}
  </svg>;
}
function PauseIcon({size=18}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>;
}
function PlusIcon({size=18}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
}
function UsersIcon({size=18}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="9" cy="7" r="4"/><path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/><path d="M21 21v-2a4 4 0 0 0-3-3.85"/></svg>;
}

function Clock({compact}) {
  const [t,setT] = useState(new Date());
  useEffect(()=>{const i=setInterval(()=>setT(new Date()),1000);return()=>clearInterval(i);},[]);
  if(compact) return <span className="clock-sm">{t.toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit',timeZone:'Europe/London'})}</span>;
  return <div className="clock-center"><div className="clock-time">{t.toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit',timeZone:'Europe/London'})}</div><div className="clock-date">{t.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short',timeZone:'Europe/London'})}</div></div>;
}

function SignalBars({quality='good'}) {
  const c = {good:'#22d47a',fair:'#f59e0b',poor:'#e24b4a',offline:'#4a7fa5'}[quality];
  const n = {good:4,fair:3,poor:1,offline:0}[quality];
  return <div className="signal-wrap">
    <div className="signal-bars">{[3,5,7,10].map((h,i)=><div key={i} className="signal-bar" style={{height:h,background:i<n?c:'#1e2d42'}}/>)}</div>
    <span className="signal-label" style={{color:c,fontSize:10}}>{quality.charAt(0).toUpperCase()+quality.slice(1)}</span>
  </div>;
}

function NetworkStatus() {
  const [q,setQ] = useState('good');
  useEffect(()=>{
    const check=()=>{
      if(!navigator.onLine){setQ('offline');return;}
      const c=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
      if(c){const r=c.rtt||0;setQ(r===0||r<100?'good':r<300?'fair':'poor');}
      else setQ('good');
    };
    check();
    const i=setInterval(check,5000);
    window.addEventListener('online',check);window.addEventListener('offline',check);
    return()=>{clearInterval(i);window.removeEventListener('online',check);window.removeEventListener('offline',check);};
  },[]);
  return <SignalBars quality={q}/>;
}

function InstallBanner() {
  const [prompt,setPrompt] = useState(null);
  const [show,setShow] = useState(false);
  const [done,setDone] = useState(false);
  useEffect(()=>{
    if(window.matchMedia('(display-mode: standalone)').matches||window.navigator.standalone){return;}
    const h=e=>{e.preventDefault();setPrompt(e);setShow(true);};
    window.addEventListener('beforeinstallprompt',h);
    window.addEventListener('appinstalled',()=>setDone(true));
    return()=>window.removeEventListener('beforeinstallprompt',h);
  },[]);
  if(done||!show) return null;
  const install=async()=>{
    if(prompt){prompt.prompt();const{outcome}=await prompt.userChoice;if(outcome==='accepted')setDone(true);}
    else alert('Chrome/Edge: click ⋮ → Install VoiceConnect\niOS Safari: Share → Add to Home Screen');
    setShow(false);
  };
  return <div className="install-banner">
    <span style={{fontSize:20}}>📱</span>
    <div className="install-banner-text"><div className="install-banner-title">Install VoiceConnect</div><div className="install-banner-sub">Better connectivity · Works offline</div></div>
    <button className="install-btn" onClick={install}>{prompt?'Install':'How?'}</button>
    <button className="install-close" onClick={()=>setShow(false)}>✕</button>
  </div>;
}

function MicTest({onBack}) {
  const [state,setState] = useState('idle');
  const [level,setLevel] = useState(0);
  const [url,setUrl] = useState(null);
  const [result,setResult] = useState('');
  const recRef=useRef();const chunksRef=useRef([]);const timerRef=useRef();const animRef=useRef();const streamRef=useRef();const audioRef=useRef();
  useEffect(()=>()=>{clearInterval(timerRef.current);cancelAnimationFrame(animRef.current);streamRef.current?.getTracks().forEach(t=>t.stop());},[]);
  const start=async()=>{
    try{
      setState('recording');setLevel(0);setUrl(null);setResult('');chunksRef.current=[];
      const stream=await navigator.mediaDevices.getUserMedia({audio:true});
      streamRef.current=stream;
      const ctx=new(window.AudioContext||window.webkitAudioContext)();
      const src=ctx.createMediaStreamSource(stream);const an=ctx.createAnalyser();an.fftSize=256;src.connect(an);
      const measure=()=>{const d=new Uint8Array(an.frequencyBinCount);an.getByteFrequencyData(d);setLevel(Math.min(100,d.reduce((a,b)=>a+b,0)/d.length*2));animRef.current=requestAnimationFrame(measure);};measure();
      const rec=new MediaRecorder(stream);recRef.current=rec;
      rec.ondataavailable=e=>{if(e.data.size>0)chunksRef.current.push(e.data);};
      rec.onstop=()=>{const blob=new Blob(chunksRef.current,{type:'audio/webm'});setUrl(URL.createObjectURL(blob));setState('done');cancelAnimationFrame(animRef.current);setLevel(0);};
      rec.start();let t=0;
      timerRef.current=setInterval(()=>{t++;if(t>=5){clearInterval(timerRef.current);rec.stop();stream.getTracks().forEach(tr=>tr.stop());}},1000);
    }catch(e){setState('error');setResult('Microphone access denied. Check browser permissions.');}
  };
  const play=()=>{if(!url||!audioRef.current)return;setState('playing');audioRef.current.src=url;audioRef.current.play();audioRef.current.onended=()=>setState('done');};
  const reset=()=>{setState('idle');setLevel(0);setUrl(null);setResult('');};
  const bars=Array.from({length:16});
  return <div className="phone">
    <audio ref={audioRef} style={{display:'none'}}/>
    <div className="topbar"><button className="btn-ghost" onClick={onBack}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5"/><path d="M12 5l-7 7 7 7"/></svg></button><span style={{fontSize:14,fontWeight:500,color:'var(--text)'}}>Microphone test</span><div/></div>
    <div className="mic-test-screen">
      <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="var(--blue)" strokeWidth="1.5"><path d="M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-6 0V4a3 3 0 0 1 3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
      <p style={{fontSize:13,color:'var(--text3)',textAlign:'center'}}>
        {state==='idle'&&'Press record to capture 5 seconds, then play it back.'}
        {state==='recording'&&'Recording…'}
        {state==='done'&&'Recording complete! Play it back to check your microphone.'}
        {state==='playing'&&'Playing back…'}
        {state==='error'&&result}
      </p>
      {state==='recording'&&<div className="level-meter">{bars.map((_,i)=><div key={i} className="level-bar" style={{height:8+i*2,background:(i/bars.length*100)<level?i<10?'#22d47a':i<13?'#f59e0b':'#e24b4a':'#1e2d42'}}/>)}</div>}
      {state==='idle'&&<button className="btn-primary" onClick={start}>🎙 Record (5s)</button>}
      {state==='done'&&<><button className="btn-primary" onClick={play}>▶ Play back</button><button className="btn-secondary" onClick={reset}>Record again</button></>}
      {state==='error'&&<button className="btn-primary" onClick={reset}>Try again</button>}
      {state==='done'&&<div className="test-result ok">✅ If you heard your voice clearly, your mic and speakers are working.</div>}
    </div>
  </div>;
}

function NetTest({onBack}) {
  const TESTS=[
    {id:'https',label:'HTTPS / TLS',desc:'Secure connection'},
    {id:'dns',label:'DNS resolution',desc:'Server reachable'},
    {id:'wss',label:'WSS port 47631',desc:'SIP signalling'},
    {id:'stun',label:'STUN / UDP',desc:'ICE discovery'},
    {id:'turn_udp',label:'TURN UDP 3478',desc:'Audio relay'},
    {id:'turn_tcp',label:'TURN TCP 3478',desc:'Relay fallback'},
    {id:'mic',label:'Microphone',desc:'Audio input'},
    {id:'speaker',label:'Speaker',desc:'Audio output'},
    {id:'codec',label:'Opus / WebRTC',desc:'Codec support'},
    {id:'browser',label:'Browser / OS',desc:'Environment'},
  ];
  const [tests,setTests]=useState(TESTS.map(t=>({...t,status:'idle',detail:'',fix:''})));
  const [running,setRunning]=useState(false);
  const [done,setDone]=useState(false);
  const upd=(id,status,detail,fix='')=>setTests(prev=>prev.map(t=>t.id===id?{...t,status,detail,fix}:t));

  const run=async()=>{
    setRunning(true);setDone(false);
    setTests(prev=>prev.map(t=>({...t,status:'running',detail:'…',fix:''})));
    upd('https',window.location.protocol==='https:'?'ok':'fail',window.location.protocol==='https:'?`Secure · ${window.location.host}`:'Not HTTPS','Use https://');
    const ua=navigator.userAgent;
    const browser=ua.includes('Chrome')?'Chrome':ua.includes('Firefox')?'Firefox':ua.includes('Safari')?'Safari':'Other';
    const os=ua.includes('Windows')?'Windows':ua.includes('Mac')?'macOS':ua.includes('Linux')?'Linux':'Other';
    const conn=navigator.connection||{};
    upd('browser','ok',`${browser} · ${os} · ${conn.effectiveType||'?'} · RTT ${conn.rtt||'?'}ms`);
    try{const s=Date.now();const r=await fetch('https://voiceconnect.dvjnoc.com/manifest.json',{method:'HEAD',cache:'no-store'});upd('dns',r.ok?'ok':'warn',`${Date.now()-s}ms · HTTP ${r.status}`);}catch(e){upd('dns','fail','Unreachable: '+e.message);}
    try{const s=Date.now();await new Promise((res,rej)=>{const ws=new WebSocket('wss://voiceconnect.dvjnoc.com:47631/ws');const t=setTimeout(()=>{ws.close();rej(new Error('Timeout'));},6000);ws.onopen=()=>{clearTimeout(t);ws.close();upd('wss','ok',`Connected in ${Date.now()-s}ms`);res();};ws.onerror=()=>{clearTimeout(t);rej(new Error('Blocked'));};});}catch(e){upd('wss','fail',e.message,'Allow TCP 47631 outbound in firewall');}
    try{const pc=new RTCPeerConnection();const o=await pc.createOffer({offerToReceiveAudio:true});const hasOpus=o.sdp.includes('opus');pc.close();upd('codec',hasOpus?'ok':'fail',`Opus: ${hasOpus?'✓':'✗'} · WebRTC: ✓`);}catch(e){upd('codec','fail','WebRTC not supported');}
    try{const stream=await navigator.mediaDevices.getUserMedia({audio:true});const label=stream.getAudioTracks()[0]?.label||'Unknown';const devs=await navigator.mediaDevices.enumerateDevices();stream.getTracks().forEach(t=>t.stop());upd('mic','ok',`${label} · ${devs.filter(d=>d.kind==='audioinput').length} device(s)`);}catch(e){upd('mic','fail',e.message,'Allow microphone in browser settings');}
    try{const devs=await navigator.mediaDevices.enumerateDevices();const spk=devs.filter(d=>d.kind==='audiooutput');upd('speaker',spk.length>0?'ok':'warn',`${spk.length} device(s)`);}catch(e){upd('speaker','warn','Could not enumerate devices');}
    try{const s=Date.now();const pc=new RTCPeerConnection({iceServers:[{urls:'stun:stun.l.google.com:19302'}]});pc.createDataChannel('t');await pc.createOffer().then(o=>pc.setLocalDescription(o));await new Promise((res,rej)=>{const t=setTimeout(()=>{pc.close();rej(new Error('Timeout — UDP blocked'));},7000);let found=false;pc.onicecandidate=e=>{if(e.candidate?.type==='srflx'&&!found){found=true;clearTimeout(t);upd('stun','ok',`Public IP: ${e.candidate.address} · ${Date.now()-s}ms`);pc.close();res();}};pc.onicegatheringstatechange=()=>{if(pc.iceGatheringState==='complete'){clearTimeout(t);pc.close();if(!found)upd('stun','warn','No public IP — UDP may be blocked');res();}};});}catch(e){upd('stun','fail',e.message,'Allow UDP outbound in firewall');}
    const turnTest=async(transport,id)=>{try{const {username,credential}=await getTurnCredentials();const s=Date.now();const pc=new RTCPeerConnection({iceServers:[{urls:`turn:${TURN_SERVER}:3478${transport==='tcp'?'?transport=tcp':''}`,username,credential}]});pc.createDataChannel('t');await pc.createOffer().then(o=>pc.setLocalDescription(o));await new Promise((res,rej)=>{const t=setTimeout(()=>{pc.close();rej(new Error(`TURN ${transport.toUpperCase()} blocked`));},8000);let found=false;pc.onicecandidate=e=>{if(e.candidate?.type==='relay'&&!found){found=true;clearTimeout(t);upd(id,'ok',`Relay ${Date.now()-s}ms`);pc.close();res();}};pc.onicegatheringstatechange=()=>{if(pc.iceGatheringState==='complete'){clearTimeout(t);pc.close();if(!found)upd(id,'warn',`No relay`);res();}};});}catch(e){upd(id,'fail',e.message,`Allow ${transport.toUpperCase()} 3478 outbound`);}};
    await turnTest('udp','turn_udp');await turnTest('tcp','turn_tcp');
    setRunning(false);setDone(true);
  };
  useEffect(()=>{run();},[]);
  const icon=s=>({idle:'○',running:'🔄',ok:'✅',warn:'⚠️',fail:'❌'}[s]||'○');
  const fails=tests.filter(t=>t.status==='fail');
  const allOk=done&&tests.every(t=>t.status==='ok');
  const copyReport=()=>{
    const NL=String.fromCharCode(10);
    const lines=['VoiceConnect Network Diagnostics','================================',new Date().toLocaleString('en-GB',{timeZone:'Europe/London'}),''].concat(tests.map(t=>'['+({ok:'OK',fail:'FAIL',warn:'WARN'}[t.status]||'?')+'] '+t.label+': '+t.detail)).concat(['',fails.length?'Issues: '+fails.map(f=>f.label+' → '+f.fix).join(' | '):'No issues.']).join(NL);
    navigator.clipboard?.writeText(lines).then(()=>alert('Copied!'));
  };
  return <div className="phone">
    <div className="topbar"><button className="btn-ghost" onClick={onBack}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5"/><path d="M12 5l-7 7 7 7"/></svg></button><span style={{fontSize:14,fontWeight:500,color:'var(--text)'}}>Network diagnostics</span><button className="btn-ghost" onClick={copyReport}>📄</button></div>
    <div className="nettest-scroll">
      {done&&<div className={`net-result-header ${allOk?'ok':fails.length?'fail':'warn'}`}>{allOk?'✅ All checks passed — ready to call':fails.length?`❌ ${fails.length} issue(s) found`:`⚠️ Some warnings`}</div>}
      {tests.map(t=><div key={t.id} className="net-item"><span className="net-icon">{icon(t.status)}</span><div><div className="net-label">{t.label}</div><div className="net-desc">{t.desc}</div>{t.detail&&<div className="net-detail">{t.detail}</div>}{(t.status==='fail'||t.status==='warn')&&t.fix&&<div className="net-fix">💡 {t.fix}</div>}</div></div>)}
      <div style={{display:'flex',gap:8}}>
        <button className="run-again-btn" style={{flex:1}} onClick={run} disabled={running}>{running?'Running…':'🔄 Run again'}</button>
        <button className="copy-results-btn" style={{flex:1}} onClick={copyReport}>📄 Copy</button>
      </div>
    </div>
  </div>;
}

export default function App() {
  const [screen,setScreen]=useState(SCREEN.LOGIN);
  const [tab,setTab]=useState(TAB.KEYPAD);
  const [ext,setExt]=useState('');
  const [password,setPassword]=useState('');
  const [loginErr,setLoginErr]=useState('');
  const [sipStatus,setSipStatus]=useState('disconnected');
  const [dialInput,setDialInput]=useState('');
  const [callState,setCallState]=useState(null);
  const [callInfo,setCallInfo]=useState({number:'',direction:''});
  const [muted,setMuted]=useState(false);
  const [onHold,setOnHold]=useState(false);
  const [callDur,setCallDur]=useState(0);
  const [recents,setRecents]=useState([]);
  const [contacts,setContacts]=useState(EXTENSIONS.map(e=>({ext:e,status:'offline'})));
  const [showAddCall,setShowAddCall]=useState(false);
  const [addCallInput,setAddCallInput]=useState('');
  const [heldCalls,setHeldCalls]=useState([]);
  const [confParticipants,setConfParticipants]=useState([]);
  const [debugMode,setDebugMode]=useState(()=>localStorage.getItem('vc_debug')==='true');
  const [showReport,setShowReport]=useState(false);
  const [reportData,setReportData]=useState(null);
  const [logReady,setLogReady]=useState(false);
  const [micInputs,setMicInputs]=useState([]);
  const [micOutputs,setMicOutputs]=useState([]);
  const [selInput,setSelInput]=useState(localStorage.getItem('vc_mic')||'');
  const [selOutput,setSelOutput]=useState(localStorage.getItem('vc_speaker')||'');
  const [settingsOpen,setSettingsOpen]=useState({mic:true,speaker:false,debug:false,info:false});
  const [sendStatus,setSendStatus]=useState('idle');
  const [audioLevel,setAudioLevel]=useState(0);
  const [micLevel,setMicLevel]=useState(0);
  const [netQuality,setNetQuality]=useState('good');
  const [callerName,setCallerName]=useState('');
  const [speakerVol,setSpeakerVol]=useState(1);
  const [micVol,setMicVol]=useState(1);
  const analyzerRef=useRef(null);
  const micAnalyzerRef=useRef(null);
  const audioCtxRef=useRef(null);
  const statsIntervalRef=useRef(null);

  const uaRef=useRef(null);const sessionRef=useRef(null);const remoteAudioRef=useRef(null);
  const timerRef=useRef(null);const durRef=useRef(0);const toneRef=useRef(null);
  const iceRef=useRef([{urls:'stun:stun.l.google.com:19302'}]);
  const diagRef=useRef([]);
  const presenceRef=useRef(null);

  useEffect(()=>{getIceServers().then(s=>iceRef.current=s);},[]);
  useEffect(()=>{localStorage.setItem('vc_debug',debugMode);},[debugMode]);

  const trace=useCallback((msg,data='')=>{
    diagRef.current=[...diagRef.current.slice(-199),{t:new Date().toISOString().substr(11,12),msg,data:String(data)}];
  },[]);

  const stopTimer=useCallback(()=>{clearInterval(timerRef.current);timerRef.current=null;durRef.current=0;setCallDur(0);},[]);
  const startTimer=useCallback(()=>{stopTimer();timerRef.current=setInterval(()=>{durRef.current+=1;setCallDur(durRef.current);},1000);},[stopTimer]);

  const addToRecents=useCallback((number,direction,answered,duration)=>{
    const conn=navigator.connection||{};
    const entry={number,direction,answered,duration,
      time:new Date().toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit',timeZone:'Europe/London'}),
      date:new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',timeZone:'Europe/London'}),
      report:{number,direction,answered,duration,time:new Date().toLocaleString('en-GB',{timeZone:'Europe/London'}),network:{type:conn.effectiveType||'?',rtt:conn.rtt||'?',downlink:conn.downlink||'?'},userAgent:navigator.userAgent,trace:[...diagRef.current]}
    };
    setRecents(prev=>[entry,...prev].slice(0,MAX_RECENTS));
    reportData&&setReportData(entry.report);
  },[reportData]);

  const pollPresence=useCallback(()=>{
    fetch('/api/presence').then(r=>r.json()).then(data=>{
      if(data&&data.registrations){
        setContacts(EXTENSIONS.map(e=>{
          const reg=data.registrations.find(r=>r.ext===e||r.ext===`${e}-${TENANT}`);
          const busy=data.active_calls?.includes(e);
          return {ext:e,status:busy?'busy':reg?'online':'offline'};
        }));
      }
    }).catch(()=>{});
  },[]);

  useEffect(()=>{
    if(screen===SCREEN.MAIN){
      pollPresence();
      presenceRef.current=setInterval(pollPresence,10000);
    }
    return()=>clearInterval(presenceRef.current);
  },[screen,pollPresence]);

  const loadAudioDevices=useCallback(async()=>{
    try{
      await navigator.mediaDevices.getUserMedia({audio:true}).then(s=>s.getTracks().forEach(t=>t.stop()));
      const devs=await navigator.mediaDevices.enumerateDevices();
      setMicInputs(devs.filter(d=>d.kind==='audioinput'));
      setMicOutputs(devs.filter(d=>d.kind==='audiooutput'));
    }catch(e){}
  },[]);

  useEffect(()=>{
    if(screen===SCREEN.SETTINGS) loadAudioDevices();
  },[screen,loadAudioDevices]);

  const attachAudio=useCallback((session)=>{
    try{
      const pc=session.connection;if(!pc)return;
      const setupAnalyzer=(stream)=>{
        try{
          const ctx=new(window.AudioContext||window.webkitAudioContext)();
          audioCtxRef.current=ctx;
          // Remote audio analyzer
          const src=ctx.createMediaStreamSource(stream);
          const an=ctx.createAnalyser();an.fftSize=256;
          src.connect(an);
          analyzerRef.current=an;
          // Mic analyzer
          navigator.mediaDevices.getUserMedia({audio:true}).then(micStream=>{
            const micSrc=ctx.createMediaStreamSource(micStream);
            const micAn=ctx.createAnalyser();micAn.fftSize=256;
            micSrc.connect(micAn);
            micAnalyzerRef.current=micAn;
          }).catch(()=>{});
          const measure=()=>{
            if(!analyzerRef.current)return;
            const d=new Uint8Array(an.frequencyBinCount);
            an.getByteFrequencyData(d);
            const avg=d.reduce((a,b)=>a+b,0)/d.length;
            setAudioLevel(Math.min(100,avg*2.5));
            if(micAnalyzerRef.current){
              const md=new Uint8Array(micAnalyzerRef.current.frequencyBinCount);
              micAnalyzerRef.current.getByteFrequencyData(md);
              setMicLevel(Math.min(100,md.reduce((a,b)=>a+b,0)/md.length*2.5));
            }
            requestAnimationFrame(measure);
          };
          measure();
        }catch(e){}
      };
      pc.ontrack=e=>{
        if(remoteAudioRef.current&&e.streams[0]){
          remoteAudioRef.current.srcObject=e.streams[0];
          remoteAudioRef.current.volume=speakerVol;
          remoteAudioRef.current.play().catch(()=>{});
          setupAnalyzer(e.streams[0]);
        }
      };
      pc.getReceivers().forEach(r=>{
        if(r.track?.kind==='audio'&&remoteAudioRef.current){
          const stream=new MediaStream([r.track]);
          remoteAudioRef.current.srcObject=stream;
          remoteAudioRef.current.volume=speakerVol;
          remoteAudioRef.current.play().catch(()=>{});
          setupAnalyzer(stream);
        }
      });
      // Network quality via RTCStats
      statsIntervalRef.current=setInterval(()=>{
        try{
          pc.getStats().then(stats=>{
            stats.forEach(r=>{
              if(r.type==='inbound-rtp'&&r.kind==='audio'){
                const loss=r.packetsLost||0;
                const recv=r.packetsReceived||1;
                const pct=loss/(loss+recv)*100;
                const jitter=(r.jitter||0)*1000;
                if(pct>10||jitter>50)setNetQuality('poor');
                else if(pct>3||jitter>20)setNetQuality('fair');
                else setNetQuality('good');
              }
            });
          }).catch(()=>{});
        }catch(e){}
      },3000);
    }catch(e){}
  },[speakerVol]);

  const handleCallEnded=useCallback((number,direction,answered)=>{
    const dur=durRef.current;
    stopTimer();stopTone(toneRef);
    trace('Call ended',`duration=${dur}s answered=${answered}`);
    addToRecents(number,direction,answered,dur);
    sessionRef.current=null;
    setCallState(null);setCallInfo({number:'',direction:''});setMuted(false);setOnHold(false);setHeldCalls([]);
    setTimeout(()=>setLogReady(true),500);
    setScreen(SCREEN.MAIN);
  },[stopTimer,addToRecents,trace]);

  const connect=useCallback(async()=>{
    if(!ext||!password){setLoginErr('Enter extension and password.');return;}
    setLoginErr('');setSipStatus('connecting');
    try{
      const stream=await navigator.mediaDevices.getUserMedia({audio:true});
      stream.getTracks().forEach(t=>t.stop());
    }catch(e){setLoginErr('Microphone access required.');setSipStatus('disconnected');return;}
    const servers=await getIceServers();iceRef.current=servers;
    const socket=new JsSIP.WebSocketInterface(WS_SERVER);
    const ua=new JsSIP.UA({sockets:[socket],uri:`sip:${ext}-${TENANT}@${SIP_DOMAIN}`,password,display_name:ext,register:true,session_timers:false});
    ua.on('registered',()=>{setSipStatus('registered');setScreen(SCREEN.MAIN);trace('SIP registered',`${ext}-${TENANT}@${SIP_DOMAIN}`);});
    ua.on('registrationFailed',e=>{setSipStatus('error');setLoginErr(`Registration failed: ${e.cause}`);trace('SIP reg failed',e.cause);});
    ua.on('disconnected',()=>{setSipStatus('disconnected');trace('WS disconnected');if(uaRef.current){setTimeout(()=>{try{uaRef.current?.start();}catch(e){}},3000);}});
    ua.on('newRTCSession',data=>{
      const session=data.session;
      const number=session.remote_identity?.uri?.user||'Unknown';
      if(session.direction==='incoming'){
        if(sessionRef.current){session.terminate();return;}
        sessionRef.current=session;
        setCallInfo({number,direction:'incoming'});setCallState('incoming');setScreen(SCREEN.CALL);
        playTone(toneRef,'incoming');
        session.on('ended',()=>handleCallEnded(number,'incoming',true));
        session.on('failed',()=>handleCallEnded(number,'incoming',false));
      }
    });
    ua.start();uaRef.current=ua;
  },[ext,password,handleCallEnded,trace]);

  const dial=useCallback((target)=>{
    const number=target||dialInput;if(!number||!uaRef.current)return;
    setLogReady(false);
    const session=uaRef.current.call(`sip:${number}@${SIP_DOMAIN}`,{
      mediaConstraints:{audio:true,video:false},
      rtcOfferConstraints:{offerToReceiveAudio:true,offerToReceiveVideo:false},
      pcConfig:{iceServers:iceRef.current,iceTransportPolicy:'all'},
    });
    sessionRef.current=session;
    setCallInfo({number,direction:'outgoing'});setCallState('outgoing');setScreen(SCREEN.CALL);
    playTone(toneRef,'outgoing');
    trace('INVITE sent',`sip:${number}@${SIP_DOMAIN}`);
    // Lookup caller name from contacts
    const contact=contacts.find(c=>c.ext===number||c.ext===number.replace(/-99909255$/,''));
    setCallerName(contact?`Ext ${contact.ext}`:'');
    session.on('confirmed',()=>{stopTone(toneRef);setCallState('active');startTimer();attachAudio(session);
      trace('Call confirmed - checking ICE');
      try{session.connection?.getStats().then(stats=>stats.forEach(r=>{if(r.type==='local-candidate')trace('Local ICE',`${r.candidateType} ${r.address}:${r.port}`);})).catch(()=>{});}catch(e){}
    });
    session.on('peerconnection',()=>attachAudio(session));
    session.on('ended',()=>handleCallEnded(number,'outgoing',true));
    session.on('failed',e=>{trace('Call failed',e?.cause||'unknown');stopTone(toneRef);handleCallEnded(number,'outgoing',false);});
  },[dialInput,startTimer,handleCallEnded,attachAudio,trace]);

  const answer=useCallback(()=>{
    if(!sessionRef.current)return;stopTone(toneRef);
    sessionRef.current.answer({mediaConstraints:{audio:true,video:false},pcConfig:{iceServers:iceRef.current,iceTransportPolicy:'all'}});
    setCallState('active');startTimer();
    sessionRef.current.on('confirmed',()=>attachAudio(sessionRef.current));
  },[startTimer,attachAudio]);

  const hangup=useCallback(()=>{
    stopTone(toneRef);
    clearInterval(statsIntervalRef.current);
    if(audioCtxRef.current){try{audioCtxRef.current.close();}catch(e){} audioCtxRef.current=null;}
    analyzerRef.current=null;micAnalyzerRef.current=null;
    setAudioLevel(0);setMicLevel(0);setNetQuality('good');setCallerName('');
    try{sessionRef.current?.terminate();}catch(e){}
  },[]);
  const toggleMute=useCallback(()=>{if(!sessionRef.current)return;if(muted)sessionRef.current.unmute({audio:true});else sessionRef.current.mute({audio:true});setMuted(m=>!m);},[muted]);
  const toggleHold=useCallback(()=>{if(!sessionRef.current)return;if(onHold)sessionRef.current.unhold();else sessionRef.current.hold();setOnHold(h=>!h);},[onHold]);
  const disconnect=useCallback(()=>{const ua=uaRef.current;uaRef.current=null;if(ua)ua.stop();setSipStatus('disconnected');setScreen(SCREEN.LOGIN);},[]);

  const dialAddCall=useCallback(()=>{
    if(!addCallInput||!uaRef.current)return;
    if(sessionRef.current&&callState==='active'){sessionRef.current.hold();setOnHold(true);}
    const session2=uaRef.current.call(`sip:${addCallInput}@${SIP_DOMAIN}`,{mediaConstraints:{audio:true,video:false},pcConfig:{iceServers:iceRef.current,iceTransportPolicy:'all'}});
    setHeldCalls(prev=>[...prev,{session:sessionRef.current,number:callInfo.number}]);
    sessionRef.current=session2;
    setCallInfo({number:addCallInput,direction:'outgoing'});setCallState('outgoing');
    setShowAddCall(false);setAddCallInput('');
    session2.on('confirmed',()=>{setCallState('active');startTimer();attachAudio(session2);});
    session2.on('ended',()=>{if(heldCalls.length>0){const prev=heldCalls[heldCalls.length-1];sessionRef.current=prev.session;setCallInfo({number:prev.number,direction:'outgoing'});setCallState('active');prev.session.unhold();setHeldCalls(h=>h.slice(0,-1));}else{handleCallEnded(addCallInput,'outgoing',true);}});
  },[addCallInput,callState,callInfo,heldCalls,startTimer,attachAudio,handleCallEnded]);

  const swapCall=useCallback(()=>{
    if(heldCalls.length===0)return;
    const prev=heldCalls[heldCalls.length-1];
    sessionRef.current?.hold();
    prev.session.unhold();
    setHeldCalls(h=>[...h.slice(0,-1),{session:sessionRef.current,number:callInfo.number}]);
    sessionRef.current=prev.session;
    setCallInfo({number:prev.number,direction:'outgoing'});
    setCallState('active');
    attachAudio(prev.session);
  },[heldCalls,callInfo,attachAudio]);

  const mergeToConf=useCallback(()=>{
    const all=[{number:callInfo.number,session:sessionRef.current},...heldCalls];
    setConfParticipants(all.map(c=>c.number));
    setHeldCalls([]);
    setScreen(SCREEN.CONF);
  },[callInfo,heldCalls]);

  const openReport=useCallback((report)=>{setReportData(report);setShowReport(true);},[]);

  const copyReport=useCallback(()=>{
    if(!reportData)return;
    const NL=String.fromCharCode(10);
    const lines=['VoiceConnect Call Report','========================',`Time: ${reportData.time}`,`Extension: ${ext}`,`Called: ${reportData.number}`,`Direction: ${reportData.direction}`,`Answered: ${reportData.answered?'Yes':'No'}`,`Duration: ${reportData.duration}s`,`Network: ${reportData.network?.type} RTT:${reportData.network?.rtt}ms`,`Browser: ${reportData.userAgent}`,'','--- SIP/ICE Trace ---',...(reportData.trace||[]).map(e=>`${e.t} ${e.msg} ${e.data}`)].join(NL);
    navigator.clipboard?.writeText(lines).then(()=>alert('Copied!'));
  },[reportData,ext]);

  const sendReport=useCallback(async()=>{
    if(!reportData)return;setSendStatus('sending');
    try{const r=await fetch('/api/report',{method:'POST',headers:{'Content-Type':'application/json','X-Report-Token':'vc-debug-r9x2k7m4p1'},body:JSON.stringify({ext,...reportData})});setSendStatus(r.ok?'sent':'error');}
    catch(e){setSendStatus('error');}
  },[reportData,ext]);

  const statusColor={registered:'#22d47a',connecting:'#f59e0b',error:'#e24b4a',disconnected:'#4a7fa5'}[sipStatus]||'#4a7fa5';
  const statusLabel={registered:'Connected',connecting:'Connecting…',error:'Error',disconnected:'Disconnected'}[sipStatus]||'Disconnected';

  const KEYS=[['1',''],['2','ABC'],['3','DEF'],['4','GHI'],['5','JKL'],['6','MNO'],['7','PQRS'],['8','TUV'],['9','WXYZ'],['*',''],['0','+'],['#','']];

  if(screen===SCREEN.MIC_TEST) return <div className="app"><MicTest onBack={()=>setScreen(SCREEN.SETTINGS)}/></div>;
  if(screen===SCREEN.NET_TEST) return <div className="app"><NetTest onBack={()=>setScreen(SCREEN.SETTINGS)}/></div>;

  if(screen===SCREEN.SETTINGS) return <div className="app"><div className="phone">
    <div className="topbar"><button className="btn-ghost" onClick={()=>setScreen(SCREEN.MAIN)}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5"/><path d="M12 5l-7 7 7 7"/></svg></button><span style={{fontSize:14,fontWeight:500,color:'var(--text)'}}>Settings</span><div/></div>
    <div className="settings-scroll">
      {[{id:'mic',label:'🎙 Microphone (input)'},{id:'speaker',label:'🔊 Speaker (output)'},{id:'debug',label:'🔧 Debug mode'},{id:'info',label:'ℹ️ System info'}].map(({id,label})=><div key={id} className="settings-section">
        <button className="settings-section-btn" onClick={()=>setSettingsOpen(o=>({...o,[id]:!o[id]}))}>
          <span>{label}</span><span className={`chevron${settingsOpen[id]?' open':''}`}>▼</span>
        </button>
        {settingsOpen[id]&&<div className="settings-body">
          {id==='mic'&&<>
            {micInputs.length===0&&<div style={{padding:'12px 16px',fontSize:12,color:'var(--text3)'}}>No microphone found</div>}
            {micInputs.map(d=><label key={d.deviceId} className="device-row"><input type="radio" name="mic" checked={selInput===d.deviceId||(!selInput&&d.deviceId==='default')} onChange={()=>{setSelInput(d.deviceId);localStorage.setItem('vc_mic',d.deviceId);}}/><div className="device-info"><div className="device-name">{d.label||'Microphone'}</div><div className="device-type">{d.deviceId==='default'?'System default':d.deviceId==='communications'?'Communications':'USB / External'}</div></div>{(selInput===d.deviceId||(!selInput&&d.deviceId==='default'))&&<span className="active-badge">Active</span>}</label>)}
            <button className="settings-test-btn" onClick={()=>setScreen(SCREEN.MIC_TEST)}>🎙 Test microphone</button>
          </>}
          {id==='speaker'&&<>
            {micOutputs.length===0&&<div style={{padding:'12px 16px',fontSize:12,color:'var(--text3)'}}>No speaker found</div>}
            {micOutputs.map(d=><label key={d.deviceId} className="device-row"><input type="radio" name="spk" checked={selOutput===d.deviceId||(!selOutput&&d.deviceId==='default')} onChange={()=>{setSelOutput(d.deviceId);localStorage.setItem('vc_speaker',d.deviceId);}}/><div className="device-info"><div className="device-name">{d.label||'Speaker'}</div><div className="device-type">{d.deviceId==='default'?'System default':d.deviceId==='communications'?'Communications':'USB / External'}</div></div>{(selOutput===d.deviceId||(!selOutput&&d.deviceId==='default'))&&<span className="active-badge">Active</span>}</label>)}
          </>}
          {id==='debug'&&<>
            <div className="toggle-row"><div className="toggle-info"><div className="toggle-label">Enable call diagnostics</div><div className="toggle-sub">Shows 🔍 report button and network test tool</div></div><div className={`toggle${debugMode?' on':''}`} onClick={()=>setDebugMode(d=>!d)}><div className="toggle-knob"/></div></div>
            {debugMode&&<div style={{padding:'4px 16px 8px',fontSize:11,color:'#85b7eb'}}>Debug ON — report button appears in recents after calls.</div>}
            <div className={`debug-tool-row${debugMode?' enabled':''}`} onClick={()=>debugMode&&setScreen(SCREEN.MIC_TEST)}><span className="debug-icon">🎙</span><div><div style={{fontSize:12,color:'var(--text2)'}}>Microphone test</div><div className="device-type">Record and play back</div></div></div>
            <div className={`debug-tool-row${debugMode?' enabled':''}`} onClick={()=>debugMode&&dial('9196')}><span className="debug-icon">🔊</span><div><div style={{fontSize:12,color:'var(--text2)'}}>Echo test (9196)</div><div className="device-type">Hear your voice back</div></div></div>
            <div className={`debug-tool-row${debugMode?' enabled':''}`} onClick={()=>debugMode&&dial('9191')}><span className="debug-icon">🕐</span><div><div style={{fontSize:12,color:'var(--text2)'}}>Time test (9191)</div><div className="device-type">Server reads the time</div></div></div>
            <div className={`debug-tool-row${debugMode?' enabled':''}`} onClick={()=>debugMode&&setScreen(SCREEN.NET_TEST)}><span className="debug-icon">🌐</span><div><div style={{fontSize:12,color:'var(--text2)'}}>Network diagnostics</div><div className="device-type">Test all ports and TURN relay</div></div></div>
          </>}
          {id==='info'&&<>
            <div className="info-row"><span className="info-label">Server</span><span className="info-val">voiceconnect.dvjnoc.com</span></div>
            <div className="info-row"><span className="info-label">WSS port</span><span className="info-val">47631</span></div>
            <div className="info-row"><span className="info-label">TURN port</span><span className="info-val">3478 UDP/TCP</span></div>
            <div className="info-row"><span className="info-label">Encryption</span><span className="info-val">WSS + SRTP/DTLS</span></div>
            <div className="info-row"><span className="info-label">TLS cert</span><span className="info-val">Valid to 22 Sep 2026</span></div>
            <div className="info-row"><span className="info-label">Browser</span><span className="info-val">{navigator.userAgent.includes('Chrome')?'Chrome':navigator.userAgent.includes('Firefox')?'Firefox':'Other'}</span></div>
          </>}
        </div>}
      </div>)}
    </div>
  </div></div>;

  if(screen===SCREEN.CONF) return <div className="app"><div className="phone">
    <div className="conf-header"><span className="conf-title">Conference</span><span className="conf-timer">{formatDur(callDur)}</span></div>
    <div className="conf-body">
      <div className="conf-section-title">Participants ({confParticipants.length+1})</div>
      <div className="participant-card"><div className="avatar" style={{background:'#0d3d22',color:'#22d47a'}}>{ext.slice(-2)}</div><div style={{flex:1}}><div className="contact-name">You ({ext})</div><div className="contact-sub">Host</div></div><div className="part-dot" style={{background:'#22d47a'}}/></div>
      {confParticipants.map((p,i)=><div key={i} className="participant-card"><div className="avatar">{p.slice(-2)}</div><div style={{flex:1}}><div className="contact-name">{p}</div><div className="contact-sub">{p.match(/^200\d$/)?'Internal':'External'}</div></div><div className="part-dot" style={{background:'#22d47a'}}/></div>)}
      {confParticipants.length<MAX_CONF-1&&<div className="add-part" onClick={()=>setShowAddCall(true)}><div className="add-icon"><PlusIcon size={14}/></div><span className="add-label">Add participant</span></div>}
      <div className="conf-actions">
        <div className="conf-action"><div className="conf-action-btn" onClick={toggleMute}><MicIcon crossed={muted} size={16}/></div><span style={{fontSize:9,color:'var(--text3)'}}>{muted?'Unmute':'Mute'}</span></div>
        <div className="conf-action"><div className="conf-action-btn" onClick={()=>{stopTone(toneRef);try{sessionRef.current?.terminate();}catch(e){}setScreen(SCREEN.MAIN);}}><HangupIcon size={16}/></div><span style={{fontSize:9,color:'var(--red)'}}>End all</span></div>
        <div className="conf-action"><div className="conf-action-btn"><PlusIcon size={16}/></div><span style={{fontSize:9,color:'var(--text3)'}}>Add</span></div>
      </div>
    </div>
    {showAddCall&&<div className="overlay-bg">
      <div className="overlay-sheet" style={{position:'relative'}}>
        <button className="overlay-close" onClick={()=>setShowAddCall(false)}>✕</button>
        <div className="overlay-title">Add to conference</div>
        <div className="mini-display">{addCallInput||<span style={{color:'var(--text3)'}}>Enter number</span>}</div>
        <div className="mini-keypad">{KEYS.map(([k,s])=><div key={k} className="mini-key" onClick={()=>setAddCallInput(p=>p+k)}><span>{k}</span><span className="mini-key-sub">{s}</span></div>)}</div>
        <button className="mini-call-btn" onClick={dialAddCall}>📞 Add to conference</button>
      </div>
    </div>}
  </div></div>;

  if(screen===SCREEN.CALL) return <div className="app"><div className="phone">
    <audio ref={remoteAudioRef} autoPlay playsInline/>
    <div className="call-screen">
      <div className="call-header">
        <span className="call-status-label" style={{color:callState==='incoming'?'#f59e0b':callState==='active'?'#22d47a':'#4a7fa5'}}>{callState==='incoming'?'Incoming':callState==='outgoing'?'Calling…':'Active call'}</span>
        {callState==='active'&&<span className="call-timer">{formatDur(callDur)}</span>}
      </div>
      <div className="call-body">
        {/* Network quality badge */}
        {callState==='active'&&<div className="net-quality-badge" style={{background:netQuality==='good'?'rgba(34,212,122,0.1)':netQuality==='fair'?'rgba(245,158,11,0.1)':'rgba(226,75,74,0.1)',border:`1px solid ${netQuality==='good'?'#22d47a':netQuality==='fair'?'#f59e0b':'#e24b4a'}`,borderRadius:20,padding:'3px 10px',fontSize:10,color:netQuality==='good'?'#22d47a':netQuality==='fair'?'#f59e0b':'#e24b4a',marginBottom:8,display:'flex',alignItems:'center',gap:4}}>
          <div style={{width:6,height:6,borderRadius:'50%',background:netQuality==='good'?'#22d47a':netQuality==='fair'?'#f59e0b':'#e24b4a'}}/>
          {netQuality==='good'?'Good signal':netQuality==='fair'?'Fair signal':'Poor signal'}
        </div>}
        <div className="call-avatar"><svg width="40" height="40" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" fill="#4a7fa5"/><path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" stroke="#4a7fa5" strokeWidth="1.5"/></svg></div>
        <div className="call-number">{callerName||callInfo.number}</div>
        {callerName&&<div className="call-sub">{callInfo.number}</div>}
        {callState==='outgoing'&&<div className="ringback"><div className="rb-dot"/><div className="rb-dot"/><div className="rb-dot"/></div>}
        {callState==='active'&&<div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:6,width:'100%',padding:'0 24px'}}>
          {/* Remote audio bars — animated from real level */}
          <div className="audio-bars">
            {Array.from({length:12}).map((_,i)=>{
              const target=audioLevel/100;
              const wave=Math.sin(i*0.8)*0.4+0.6;
              const h=Math.max(3,Math.round(target*wave*24+(Math.random()*2)));
              return <div key={i} className="audio-bar" style={{height:h,transition:'height 0.1s ease',opacity:0.6+target*0.4}}/>;
            })}
          </div>
          <div style={{fontSize:9,color:'var(--text3)'}}>Speaker</div>
          {/* Speaker volume */}
          <div style={{display:'flex',alignItems:'center',gap:8,width:'100%'}}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--text3)" strokeWidth="1.5"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>
            <input type="range" min="0" max="1" step="0.05" value={speakerVol}
              onChange={e=>{const v=parseFloat(e.target.value);setSpeakerVol(v);if(remoteAudioRef.current)remoteAudioRef.current.volume=v;}}
              style={{flex:1,accentColor:'var(--green)',height:3}}/>
          </div>
          {/* Mic level indicator */}
          <div style={{display:'flex',alignItems:'center',gap:8,width:'100%'}}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--text3)" strokeWidth="1.5"><path d="M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-6 0V4a3 3 0 0 1 3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/></svg>
            <div style={{flex:1,height:3,background:'var(--border)',borderRadius:2,overflow:'hidden'}}>
              <div style={{height:'100%',width:`${micLevel}%`,background:micLevel>80?'#e24b4a':micLevel>50?'#f59e0b':'#22d47a',borderRadius:2,transition:'width 0.1s'}}/>
            </div>
          </div>
        </div>}
        {callState==='incoming'&&<div className="incoming-actions">
          <div className="incoming-action"><div className="decline-btn" onClick={hangup}><HangupIcon size={24}/></div><span style={{fontSize:10,color:'var(--text3)'}}>Decline</span></div>
          <div className="incoming-action"><div className="answer-btn" onClick={answer}><PhoneIcon size={24}/></div><span style={{fontSize:10,color:'var(--text3)'}}>Answer</span></div>
        </div>}
        {(callState==='outgoing'||callState==='active')&&<>
          {heldCalls.length>0&&heldCalls.map((h,i)=><div key={i} className="held-call-card"><div className="held-info"><div className="held-num">{h.number}</div><div className="held-status">On hold</div></div><div className="held-actions"><div className="swap-btn" onClick={swapCall}>Swap</div>{heldCalls.length+1<=MAX_CONF&&<div className="merge-btn" onClick={mergeToConf}>Merge</div>}</div></div>)}
          {callState==='active'&&<div className="call-actions">
            <div className="call-action"><div className={`action-btn${muted?' active-mute':''}`} onClick={toggleMute}><MicIcon crossed={muted} size={18}/></div><span className="action-label">{muted?'Unmute':'Mute'}</span></div>
            <div className="call-action"><div className={`action-btn${onHold?' active-hold':''}`} onClick={toggleHold}><PauseIcon size={18}/></div><span className="action-label" style={{color:onHold?'var(--amber)':'var(--text3)'}}>{onHold?'Resume':'Hold'}</span></div>
            <div className="call-action"><div className="action-btn blue" onClick={()=>setShowAddCall(true)}><PlusIcon size={18}/></div><span className="action-label" style={{color:'var(--blue)'}}>Add call</span></div>
          </div>}
          <div className="end-call-wrap"><div className="end-btn" onClick={hangup}><HangupIcon size={24}/></div><span style={{fontSize:10,color:'var(--text3)'}}>End call</span></div>
        </>}
      </div>
    </div>
    {showAddCall&&<div className="overlay-bg">
      <div className="overlay-sheet" style={{position:'relative'}}>
        <button className="overlay-close" onClick={()=>setShowAddCall(false)}>✕</button>
        <div className="overlay-title">Add call</div>
        <div className="mini-display">{addCallInput||<span style={{color:'var(--text3)'}}>Enter number</span>}</div>
        <div className="mini-keypad">{KEYS.map(([k,s])=><div key={k} className="mini-key" onClick={()=>setAddCallInput(p=>p+k)}><span>{k}</span><span className="mini-key-sub">{s}</span></div>)}</div>
        <button className="mini-call-btn" onClick={dialAddCall}>📞 Call</button>
      </div>
    </div>}
  </div></div>;

  return <div className="app">
    <audio ref={remoteAudioRef} autoPlay playsInline/>
    <div className="phone">
      {screen===SCREEN.LOGIN&&<div className="login-screen">
        <InstallBanner/>
        <div className="brand">
          <div className="brand-icon"><PhoneIcon size={28}/></div>
          <div className="brand-name">VoiceConnect</div>
          <div className="brand-sub">Enterprise voice, anywhere</div>
        </div>
        <div className="login-form">
          <div className="field"><label>Extension</label><input type="tel" placeholder="2001" value={ext} onChange={e=>setExt(e.target.value)} onKeyDown={e=>e.key==='Enter'&&connect()}/></div>
          <div className="field"><label>Password</label><input type="password" placeholder="••••••••" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==='Enter'&&connect()}/></div>
          {loginErr&&<p className="error-msg">{loginErr}</p>}
          <button className="btn-primary" onClick={connect} disabled={sipStatus==='connecting'}>{sipStatus==='connecting'?'Connecting…':'Sign in'}</button>
        </div>
        <div className="login-footer">
          <span className="security-badge">🔒 WSS + SRTP encrypted</span>
          <span>·</span><span>TURN relay enabled</span>
        </div>
      </div>}

      {screen===SCREEN.MAIN&&<>
        <div className="topbar">
          <div className="topbar-left">
            <div className="status-dot" style={{background:statusColor}}/>
            <div><div className="ext-name">Ext {ext}</div><div className="ext-status">{statusLabel}</div></div>
          </div>
          <div className="topbar-right">
            <NetworkStatus/>
            <Clock compact/>
            <button className="btn-ghost" onClick={()=>{setScreen(SCREEN.SETTINGS);loadAudioDevices();}} title="Settings">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>
            </button>
            <button className="btn-ghost" onClick={disconnect}>Out</button>
          </div>
        </div>

        {tab===TAB.KEYPAD&&<div className="keypad-content">
          <Clock/>
          <div className="dial-display">
            {dialInput?<span className="dial-number">{dialInput}</span>:<span className="dial-placeholder">Enter number or extension</span>}
            {dialInput&&<button className="del-btn" onClick={()=>setDialInput(p=>p.slice(0,-1))}>⌫</button>}
          </div>
          <div className="keypad-grid">{KEYS.map(([k,s])=><div key={k} className="key" onClick={()=>setDialInput(p=>p+k)}><span className="key-num">{k}</span><span className="key-sub">{s}</span></div>)}</div>
          <div className="call-btn-wrap"><div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:4}}><button className="call-btn" onClick={()=>dial()} disabled={!dialInput}><PhoneIcon size={26}/></button><span style={{fontSize:10,color:'var(--text3)'}}>Call</span></div></div>
        </div>}

        {tab===TAB.RECENTS&&<>
          <div className="screen-header">Recents</div>
          <div className="list-scroll">
            {recents.length===0&&<div className="empty-state"><span style={{fontSize:32}}>📞</span><span>No calls yet</span></div>}
            {recents.map((c,i)=><div key={i} className="recent-item" onClick={()=>{setDialInput(c.number);setTab(TAB.KEYPAD);}}>
              <span className={`dir-arrow ${c.answered?c.direction==='incoming'?'arrow-in':'arrow-out':'arrow-missed'}`}>{c.direction==='incoming'?'↙':'↗'}</span>
              <div className="recent-info"><div className="recent-num">{c.number}</div><div className="recent-meta">{c.direction} · {c.date} {c.time}{c.duration>0?` · ${formatDur(c.duration)}`:' · missed'}</div></div>
              <div style={{display:'flex',gap:6,alignItems:'center'}}>
                {debugMode&&c.report&&logReady&&<button className="small-call-btn" style={{background:'#0a1830',borderColor:'#1e3a5f',color:'#85b7eb'}} onClick={e=>{e.stopPropagation();openReport(c.report);}}>🔍</button>}
                <button className="small-call-btn" onClick={e=>{e.stopPropagation();dial(c.number);}}>Call</button>
              </div>
            </div>)}
          </div>
        </>}

        {tab===TAB.CONTACTS&&<>
          <div className="screen-header">Directory</div>
          <div className="list-scroll">
            <div className="list-section-title">Internal extensions</div>
            {contacts.map(c=><div key={c.ext} className="contact-item" onClick={()=>{setDialInput(c.ext);setTab(TAB.KEYPAD);}}>
              <div className="avatar">{c.ext.slice(-2)}</div>
              <div style={{flex:1}}><div className="contact-name">Ext {c.ext}{c.ext===ext?' · You':''}</div><div className="contact-sub">voiceconnect.dvjnoc.com</div></div>
              <span className={`status-badge ${c.status==='online'?'badge-online':c.status==='busy'?'badge-busy':'badge-offline'}`}>{c.status.charAt(0).toUpperCase()+c.status.slice(1)}</span>
            </div>)}
            <div className="dir-refresh">Updated every 10s · tap to dial</div>
          </div>
        </>}

        <div className="bottom-nav">
          {[{id:TAB.KEYPAD,label:'Keypad',icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="4" width="4" height="16" rx="1"/><rect x="10" y="4" width="4" height="16" rx="1"/><rect x="17" y="4" width="4" height="16" rx="1"/></svg>},{id:TAB.RECENTS,label:'Recents',icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 15"/></svg>},{id:TAB.CONTACTS,label:'Contacts',icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.58-7 8-7s8 3 8 7"/></svg>}].map(t=><button key={t.id} className={`nav-tab${tab===t.id?' active':''}`} onClick={()=>setTab(t.id)}>{t.icon}{t.label}</button>)}
        </div>
      </>}
    </div>

    {showReport&&<div style={{position:'fixed',inset:0,display:'flex',alignItems:'flex-end',zIndex:50}}>
      <div style={{position:'absolute',inset:0,background:'rgba(0,0,0,0.7)'}} onClick={()=>setShowReport(false)}/>
      <div className="modal-box" style={{position:'relative',zIndex:1,maxWidth:390,margin:'0 auto',width:'100%'}}>
        <div className="modal-header"><span className="modal-title">Call report</span><button className="modal-close" onClick={()=>setShowReport(false)}>✕</button></div>
        <div className="modal-body">
          <div className={`report-status ${reportData?.answered?'ok':'fail'}`}>{reportData?.answered?'✅ Call connected':'❌ Call failed / no audio'}</div>
          <div className="report-grid">
            <div className="report-row"><span>Number</span><span>{reportData?.number}</span></div>
            <div className="report-row"><span>Direction</span><span>{reportData?.direction}</span></div>
            <div className="report-row"><span>Duration</span><span>{reportData?.duration}s</span></div>
            <div className="report-row"><span>Time</span><span>{reportData?.time}</span></div>
            <div className="report-row"><span>Network</span><span>{reportData?.network?.type} · {reportData?.network?.rtt}ms RTT</span></div>
          </div>
          <div className="trace-title">SIP / ICE trace</div>
          <div className="trace-box">{(reportData?.trace||[]).map((e,i)=><div key={i} className="trace-line"><span className="trace-time">{e.t}</span><span className="trace-msg">{e.msg}</span>{e.data&&<span className="trace-data">{String(e.data).substring(0,80)}</span>}</div>)}{(!reportData?.trace||reportData.trace.length===0)&&<span style={{color:'var(--text3)',fontSize:11}}>No trace data</span>}</div>
        </div>
        <div className="modal-actions">
          <button className="modal-btn copy" onClick={copyReport}>📄 Copy</button>
          <button className={`modal-btn send ${sendStatus}`} onClick={sendReport} disabled={sendStatus==='sending'||sendStatus==='sent'}>
            {sendStatus==='idle'&&'📤 Send'}{sendStatus==='sending'&&'Sending…'}{sendStatus==='sent'&&'✅ Sent'}{sendStatus==='error'&&'❌ Failed'}
          </button>
        </div>
      </div>
    </div>}
  </div>;
}
